import React from 'react';
import './Icon.css';

const ICON_BASE = `${process.env.PUBLIC_URL || ''}/icons`;

// URL of public/icons/<name>.svg
export const iconUrl = (name) => `${ICON_BASE}/${name}.svg`;

/**
 * Icon loaded from public/icons/<name>.svg and painted with the current text colour
 * (the file is used as a CSS mask). Icons are decorative: give icon-only buttons an
 * aria-label.
 */
const Icon = ({ name, size, spin = false, className = '' }) => {
  const style = { '--icon-url': `url("${iconUrl(name)}")` };
  if (size) {
    style.width = size;
    style.height = size;
  }
  return (
    <span
      className={`icon icon-${name}${spin ? ' icon--spin' : ''}${className ? ` ${className}` : ''}`}
      style={style}
      aria-hidden="true"
    />
  );
};

export default Icon;
